// @ts-nocheck
import action from 'utils/actionCreators';

export const GET_ALL_CLIENTS_REQUEST =
  'Varicon/@src/app/Dashboard/USERMANAGEMENT/CLIENTS/GET_ALL_CLIENTS_REQUEST';
export const GET_ALL_CLIENTS_SUCCESS =
  'Varicon/@src/app/Dashboard/USERMANAGEMENT/CLIENTS/GET_ALL_CLIENTS_SUCCESS';
export const GET_ALL_CLIENTS_FAILURE =
  'Varicon/@src/app/Dashboard/USERMANAGEMENT/CLIENTS/GET_ALL_CLIENTS_FAILURE';

export const ADD_NEW_CLIENTS_REQUEST =
  'Varicon/@src/app/Dashboard/USERMANAGEMENT/CLIENTS/ADD_NEW_CLIENTS_REQUEST';
export const ADD_NEW_CLIENTS_SUCCESS =
  'Varicon/@src/app/Dashboard/USERMANAGEMENT/CLIENTS/ADD_NEW_CLIENTS_SUCCESS';
export const ADD_NEW_CLIENTS_FAILURE =
  'Varicon/@src/app/Dashboard/USERMANAGEMENT/CLIENTS/ADD_NEW_CLIENTS_FAILURE';

export const GET_CLIENT_BY_ID_REQUEST =
  'Varicon/@src/app/Dashboard/USERMANAGEMENT/CLIENTS/GET_CLIENT_BY_ID_REQUEST';
export const GET_CLIENT_BY_ID_SUCCESS =
  'Varicon/@src/app/Dashboard/USERMANAGEMENT/CLIENTS/GET_CLIENT_BY_ID_SUCCESS';
export const GET_CLIENT_BY_ID_FAILURE =
  'Varicon/@src/app/Dashboard/USERMANAGEMENT/CLIENTS/GET_CLIENT_BY_ID_FAILURE';

export const UPDATE_CLIENT_BY_ID_REQUEST =
  'Varicon/@src/app/Dashboard/USERMANAGEMENT/CLIENTS/UPDATE_CLIENT_BY_ID_REQUEST';
export const UPDATE_CLIENT_BY_ID_SUCCESS =
  'Varicon/@src/app/Dashboard/USERMANAGEMENT/CLIENTS/UPDATE_CLIENT_BY_ID_SUCCESS';
export const UPDATE_CLIENT_BY_ID_FAILURE =
  'Varicon/@src/app/Dashboard/USERMANAGEMENT/CLIENTS/UPDATE_CLIENT_BY_ID_FAILURE';

export const DELETE_CLIENT_REQUEST = 'CLIENTS/DELETE_CLIENT_REQUEST';
export const DELETE_CLIENT_SUCCESS = 'CLIENTS/DELETE_CLIENT_SUCCESS';
export const DELETE_CLIENT_FAILURE = 'CLIENTS/DELETE_CLIENT_FAILURE';

export const OPEN_CONFIRMATION_MODAL = 'CLIENTS/OPEN_CONFIRMATION_MODAL';
export const CLOSE_CONFIRMATION_MODAL = 'CLIENTS/CLOSE_CONFIRMATION_MODAL';

export const GET_STATES_REQUEST = 'GET_STATES_REQUEST';
export const GET_STATES_SUCCESS = 'GET_STATES_SUCCESS';
export const GET_STATES_FAILURE = 'GET_STATES_FAILURE';

export const getAllClientsRequest = action(GET_ALL_CLIENTS_REQUEST, 'payload');
export const getAllClientsSuccess = action(GET_ALL_CLIENTS_SUCCESS);
export const getAllClientsFailure = action(GET_ALL_CLIENTS_FAILURE);

export const addNewClientsRequest = action(ADD_NEW_CLIENTS_REQUEST, 'payload');
export const addNewClientsSuccess = action(ADD_NEW_CLIENTS_SUCCESS);
export const addNewClientsFailure = action(ADD_NEW_CLIENTS_FAILURE);

export const getClientByIdRequest = action(GET_CLIENT_BY_ID_REQUEST, 'id');
export const getClientByIdSuccess = action(GET_CLIENT_BY_ID_SUCCESS);
export const getClientByIdFailure = action(GET_CLIENT_BY_ID_FAILURE);

export const updateClientByIdRequest = action(
  UPDATE_CLIENT_BY_ID_REQUEST,
  'id',
  'payload',
);

export const updateClientByIdSuccess = action(UPDATE_CLIENT_BY_ID_SUCCESS);
export const updateClientByIdFailure = action(UPDATE_CLIENT_BY_ID_FAILURE);

export const deleteClientRequest = action(DELETE_CLIENT_REQUEST, 'payload');

export const openConfirmationModal = action(OPEN_CONFIRMATION_MODAL, 'payload');
export const closeConfirmationModal = action(CLOSE_CONFIRMATION_MODAL);

export const getStatesRequest = action(GET_STATES_REQUEST, 'payload');
